import { useRef } from 'react';

/**
 * Track when a resolver function changes (e.g. household data loads) so
 * consumers can force a re-mount by using the returned version as a key.
 */
export function useResolverVersion(
  resolveVariable: (variableName: string) => string | null
): number {
  const versionRef = useRef(0);
  const prevResolveRef = useRef(resolveVariable);
  if (prevResolveRef.current !== resolveVariable) {
    prevResolveRef.current = resolveVariable;
    versionRef.current += 1;
  }
  return versionRef.current;
}
